// Display helpers for an employee's Symmetry tax config (the sym_tax_config API shape)

// Withholding-certificate parameters the employee has a value for, in form order
export function visibleParameters(taxConfig) {
    return taxConfig.parameters
        .filter(p => p.certificate_line_no && p.parameter_name in taxConfig.tax_data)
        .slice()
        .sort((a, b) => a.certificate_line_no.localeCompare(b.certificate_line_no))
}

// Symmetry models some yes/no questions (W-4 Two Jobs) as a TRUE/FALSE pick list
function isYesNoPickList(param) {
    const values = param.list_values_parsed.map(([val]) => String(val).toUpperCase()).sort()
    return values.length === 2 && values[0] === 'FALSE' && values[1] === 'TRUE'
}

function displayValue(param, value) {
    if (param.data_type === 'Boolean' || (param.regex_type === 'PickList' && isYesNoPickList(param))) {
        return String(value).toUpperCase() === 'TRUE' ? 'Yes' : 'No'
    }
    if (param.regex_type === 'PickList' && param.list_values_parsed.length) {
        const match = param.list_values_parsed.find(([val]) => val === String(value))
        return match ? match[1] : value
    }
    // Symmetry stores numbers as text ("0.0", "2000.00"); show them without trailing zeros
    if (/^-?\d+(\.\d+)?$/.test(String(value))) {
        return String(Number(value))
    }
    return value
}

// The value in effect: the employee's, or Symmetry's default when left blank
export function formatParamValue(taxConfig, param) {
    const raw = taxConfig.tax_data[param.parameter_name]
    const isBlank = raw === undefined || raw === null || raw === ''
    const hasDefault = param.default_value !== undefined && param.default_value !== null && param.default_value !== ''
    if (isBlank && !hasDefault) {
        return 'Default'
    }
    return displayValue(param, isBlank ? param.default_value : raw)
}
